module.exports = __webpack_public_path__ + "static/media/korn-ferry-logo.7e0e4063.png";